import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
import KeyAccessPage from '../views/KeyAccess.vue'
import TextSharePage from '../views/TextShare.vue'
import TextAccessPage from '../views/TextAccess.vue'
import TestSharePage from '../views/TestShare.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/access/:id',
    name: 'KeyAccessPage',
    component: KeyAccessPage
  },
  {
    path: '/share',
    name: 'TextSharePage',
    component: TextSharePage
  },
  {
    path: '/text/:id',
    name: 'TextAccessPage',
    component: TextAccessPage
  },
  {
    path: '/test',
    name: 'TestSharePage',
    component: TestSharePage
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router